import React from 'react';
import { cn } from '../../lib/classNames';

export const StateMessage = ({ title, description, className }) => (
  <div className={cn('rounded-lg border border-dashed border-border bg-muted/30 px-6 py-8 text-center', className)}>
    <p className="mb-1 text-sm font-medium text-foreground">{title}</p>
    {description && <p className="mb-0 text-sm text-muted-foreground">{description}</p>}
  </div>
);
